import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Buttons from '@material-ui/core/Button';
import { Button, Grid, Dropdown, Radio, Input } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

class Title extends React.Component {

  state = {
    maxWidth: 'lg',
    maxWidth1: 'sm',
    maxWidth2: 'xs',
    maxWidth4: 'xs',
    fullWidth: true,
    edit: false,
    menuOption: [],
    menusOption: [],
    load: false,
    message: '',
    custom: false,
    check: 'checked',
    openStatus: false,
    checkBox: [],
    openDate: false
  }

  componentDidMount() {
    this.setMenus();
    this.setMenu();
  }

  setMenus() {
    let context = this;
    var x = [];
    let menu = ['Waiting', 'Received', 'Custom Received', 'Long Waiting'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        menuOption: x,
      });
    } catch (e) {}
  }

  setMenu() {
    let context = this;
    var x = [];
    let menu = ['Waiting', 'Received', 'Long Waiting'];
    menu.map((y) => {
      x.push({key: y, text: y, value: y});
    });
    try {
      context.setState({
        menusOption: x,
      });
    } catch (e) {}
  }

  onChange = (type) => (f, { value }) => {
    if (value == 'Custom Received') {
      this.setState({ custom: true })
    }
    else {
      this.setState({ editStatus: value })
    }
  }

  checkBoxChange = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  textboxvalue = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  save() {
    let context = this;
    let id = this.state.editId;
    let status = this.state.editStatus
    this.setState({
      load: false,
      message: 'Editing Status!!!!',
    });
    let data1 = { 'id': id, 'status': status };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/editstatus.php',
      success: function(data)
      {
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ edit: false });
          context.props.update(id, status);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  received() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let context = this;
    let stocks = this.state.received;
    let editId = this.state.editId;
    let datas = this.props.data;
    let purchase_id, partno, brand_id;
    for (var i = 0; i < datas.length; i++) {
      if (datas[i].id == editId) {
        purchase_id = datas[i].purchase_id;
        partno = datas[i].partno;
        brand_id = datas[i].brand_id;
      }
    }
    let data1 = { 'purchase_id': purchase_id, 'partno': partno, 'brand_id': brand_id,
                  'stock': stocks, 'id': editId }
    context.setState({ load: true, message: 'Inserting Data' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/insertcustomdata.php',
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ custom: false, edit: false });
          context.props.view(context.props.viewId);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleChange = (name) => event => {
    this.checkBox(name);
  };

  checkBox(id) {
    let checkBox = this.state.checkBox;
    if (checkBox.length > 0) {
      for (var i = 0; i < checkBox.length; i++) {
        if (checkBox[i].id == id) {
          this.remove(id);
          return;
        }
      }
      this.add(id);
      return;
    }
    else {
      checkBox.push({id: id});
      this.setState({
        checkBox: checkBox
      });
      return;
    }
  }

  remove(id) {
    let checkBox = this.state.checkBox;
    let removed = [];
    checkBox.map((z) =>{
      if (z.id != id) {
        removed.push({id: z.id});
      }
    })
    this.setState({
      checkBox: removed
    });
  }

  add(id) {
    let checkBox = this.state.checkBox;
    checkBox.push({id: id});
    this.setState({
      checkBox: checkBox
    });
  }

  changeStatus() {
    let checkBox = this.state.checkBox;
    if (checkBox.length > 0) {
      this.setState({ openStatus: true })
    }
    else {
      alert('Please selected check box');
    }
  }

  changeDate() {

    let checkBox = this.state.checkBox;
    console.log(checkBox);
    if (checkBox.length > 0) {
      this.setState({ openDate: true })
    }
    else {
      alert('Please selected check box');
    }
  }

  sendChangeStatus() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let context = this;
    let checkBox = this.state.checkBox;
    for (var i = 0; i < checkBox.length; i++) {
      checkBox[i].status = this.state.changeStatus;
    }

    let items = JSON.stringify(checkBox);
    let data1 = { 'items': items };
    context.setState({
      load: true,
      message: 'Adding Purchase details!!!',
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/changestatus.php',
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          context.setState({ openStatus: false });
          context.props.statusUpdates(checkBox)
        }
        else {
          alert('Error!!')
        }
      },
      error: function(err)
      {
        alert('Try Again!!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  handleDateChange = name => event => {
    let date = event.target.value;
    this.setState({ change_date: date })
  }

  handleChanges = name => event => {
    
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let context = this;
    let date = event.target.value;
    let data1 = { 'date': date, 'id': name };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/changeexepecteddate.php',
      success: function(data)
      {
        if (data == 1) {
          let datas = context.props.data;
          datas.map((x) => {
            if (x.id == name) {
              x.expected_delivary_date = date+ " 00:00:00";
            }
          });
          context.props.updateData(context.props.viewId);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err)
      {
        alert('Try Again!!')
        context.setState({
          load: false,
        })
      }
    })
  };

  saveDate() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let context = this;
    let checkBox = this.state.checkBox;
    for (var i = 0; i < checkBox.length; i++) {
      checkBox[i].date = this.state.change_date;
    }
    let items = JSON.stringify(checkBox);
    let data1 = { 'items': items };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaserequest/changeexepecteddatearray.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({ change_date: '', openDate: false, items: [] })
          context.props.updateData(context.props.viewId);
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err)
      {
        alert('Try Again!!')
        context.setState({
          load: false,
        })
      }
    })
  }

  render() {
    return (
      <div>
      <Loading load={this.state.load} message={this.state.message} />
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.props.viewOpen}
            onClose={this.props.handleClose}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Request Orders</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <table width="100%" id='table'>
                  <tr>
                    <th id='tableheader'><center></center>Sino</th>
                    <th id='tableheader'><center></center>Part Name</th>
                    <th id='tableheader'><center></center>Brand Name</th>
                    <th id='tableheader'><center></center>Stocks</th>
                    <th id='tableheader'><center></center>Status</th>
                    <th id='tableheader' style={{width: '18%'}}><center></center>Expected Delivary</th>
                    <th id='tableheader' style={{display: this.props.pendingrequestedit}}><center></center>Edit</th>
                    <th id='tableheader' style={{display: this.props.pendingrequestedit}}><center></center>Changes</th>
                  </tr>
                  { this.props.data.map((z) => {
                      let date = z.expected_delivary_date;
                      date = date.split(' ')[0];
                      return (
                        <tr>
                          <td><center>{z.sino}</center></td>
                          <td>{z.partno+'->'+z.partname}</td>
                          <td><center>{z.brandname}</center></td>
                          <td><center>{z.stock}</center></td>
                          <td><center>{z.status}</center></td>
                          <td>
                          <center>
                            <input type="date" onChange={this.handleChanges(z.id)} value={date} />
                          </center>
                          </td>
                          <td style={{cursor: 'pointer', display: this.props.pendingrequestedit}}
                              onClick={ () => { 
                                if (!this.props.menuPermission.edit) {
                                  alert('You Are Not Allow To Edit!!!');
                                  return;
                                }
                                this.setState({ edit: true, editId: z.id, editStatus: z.status }) 
                              }}>
                            <center>Edit</center>
                          </td>
                          <td style={{width: '8%', display: this.props.pendingrequestedit}}>
                            <center>
                              <Checkbox
                                id={z.id}
                                onChange={this.handleChange(z.id)}
                                color="primary"
                              />
                            </center>
                          </td>
                        </tr>
                      );
                    })
                  }
                </table>
                <br/>
              </DialogContentText>
              <DialogActions>
                <Button primary style={{display: this.props.pendingrequestedit}}
                  onClick={ () => { this.setState({ openDate: true }) }}>
                  Change Date
                </Button>
                <Button primary style={{display: this.props.pendingrequestedit}}
                  onClick={this.changeStatus.bind(this)}>
                  Change Status
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>

          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth4}  open={this.state.openStatus}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Request Orders</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={16} style={{paddingBottom: '5%'}}>
                      <Dropdown fluid
                        id="Menu" onChange={this.checkBoxChange('changeStatus')}
                        search selection options={this.state.menusOption}
                        value={this.state.changeStatus} fluid style={{ borderColor: '#5A9CBB' }} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button secondary fluid onClick={ () => { this.setState({openStatus: false}) }}>
                        Cancel
                      </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button primary fluid onClick={this.sendChangeStatus.bind(this)}>
                        Save
                      </Button>
                    </Grid.Column>
                  </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth4}  open={this.state.edit}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Request Orders</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={16} style={{paddingBottom: '5%'}}>
                      <Dropdown fluid
                        id="Menu" onChange={this.onChange('menu')}
                        search selection options={this.state.menuOption}
                        value={this.state.editStatus} fluid style={{ borderColor: '#5A9CBB' }} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button secondary fluid onClick={ () => { this.setState({edit: false}) } }>Cancel</Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button primary fluid onClick={this.save.bind(this)}>Save</Button>
                    </Grid.Column>
                  </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth1}  open={this.state.custom}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Custom Received Stocks</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <Input fluid focus onChange={this.textboxvalue('received')}
                          value={this.state.received} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button secondary fluid onClick={ () => { this.setState({custom: false}) } }>Cancel</Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button primary fluid onClick={this.received.bind(this)}>Save</Button>
                    </Grid.Column>
                  </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>

          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth2}  open={this.state.openDate}
            aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Change Details</DialogTitle>
            <DialogContent>
              <DialogContentText>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <input type='date' vlaue={this.state.change_date} onChange={this.handleDateChange('dd')} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button secondary fluid onClick={ () => { this.setState({openDate: false}) } }>Cancel</Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <Button primary fluid onClick={this.saveDate.bind(this)}>Save</Button>
                    </Grid.Column>
                  </Grid>
              </DialogContentText>
            </DialogContent>
          </Dialog>

        </React.Fragment>
      </div>
    );
  }
}

export default Title;
